import { cdnApi } from '@/helpers/api'
import { useAsyncState } from '@vueuse/core'
import { defineStore } from 'pinia'

export interface IOverlayCtaBanner {
  image: string
  imageHover: string
  link: string
  micrositeName: string
  micrositePhase: number | string
}

interface IOverlayCtaData {
  arrowRestImage: string
  arrowHoverImage: string
  Children: IOverlayCtaBanner[]
}

export const useOverlayCtaStore = defineStore('OverlayCtaStore', () => {
  const {
    state,
    isReady,
    execute: patch,
  } = useAsyncState(
    () => cdnApi.get('/overlay-cta-banners').then(({ data }) => data as IOverlayCtaData),
    {
      arrowRestImage: '',
      arrowHoverImage: '',
      Children: [],
    },
    { resetOnExecute: false }
  )
  return {
    state,
    isReady,
    patch,
  }
})
